import React, {
  useContext, useEffect, memo
} from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import { SMSPopupInfo } from '../../types/sms';
type Props = {
  smsPopupInfo: SMSPopupInfo;
  setSmsPopupInfo: React.Dispatch<React.SetStateAction<SMSPopupInfo>>;
};

const SMSThanksPopup = (props: Props): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const handleCloseBtn = (): void => {
    globalContext.gtm.pushVersionedEvent('2.x', 'SMSOptin', 'CloseSuccessModal');
    props.setSmsPopupInfo({ ...props.smsPopupInfo, showThanksPopup: false });
  };

  useEffect(() => {
    // TODO: add GA event for accountpage after it's react migration
    if (props.smsPopupInfo && props.smsPopupInfo.isFirstBoxShipped) {
      globalContext.gtm.setVirtualPage('SMS_Optin_Success_Login');
    } else {
      globalContext.gtm.setVirtualPage('SMS_Optin_Success_Activation');
    }
  }, []);

  return (
    <div className="reveal message-modal message-modal--success js-sms-message-modal" data-v-offset="" data-close-on-click="false" style={{ display: 'block' }} role="dialog" aria-hidden="false" data-yeti-box="login-and-create-account-popUp-modal" data-resize="login-and-create-account-popUp-modal" data-e="ucpld6-e" tabIndex={-1} data-events="resize">
      <button className="close-button modal-close message-modal__close js-close-thanks" data-close="" aria-label="Close modal" type="button"
        onClick={handleCloseBtn}>
        <span aria-hidden="true" className="close-button__icon">×</span>
      </button>
      <div className="message-modal__inner">
        <h2 className="message-modal__heading">{globalContext.i18n.getText('sms_thanks_heading')}</h2>
      </div>
    </div>
  );
};

export default memo(SMSThanksPopup);
